import { Alert, Box, CircularProgress, IconButton, Tooltip, Typography } from "@mui/material";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { useEffect } from "react";
import { useStudentFee } from "../hooks/useStudentFee";
import { printReceipt } from "../services/feePaymentService";

/** Finance → Receipts for a student: every receipt of their own, with Print. */
export const StudentFeeReceipts = () => {
  const { fetchFees, fees, loading, error } = useStudentFee();
  useEffect(() => {
    fetchFees();
  }, [fetchFees]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress size={28} />
      </Box>
    );
  }
  if (error) return <Alert severity="error">{error}</Alert>;

  if (fees.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          py: 4,
          border: "1px solid #eceff2",
          borderRadius: 1.5,
        }}
      >
        <ReceiptLongOutlinedIcon sx={{ color: "text.disabled" }} />
        <Typography variant="body2" color="text.secondary">
          No receipts yet.
        </Typography>
      </Box>
    );
  }

  // One compact row per receipt (same style as Outstanding): grade/section on top,
  // term and amount below, print icon on the right — fits narrow screens without scrolling.
  return (
    <Box sx={{ border: "1px solid #eceff2", borderRadius: 1.5, overflow: "hidden", bgcolor: "#ffffff" }}>
      {fees.map((fee, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            px: 2,
            py: 1.25,
            borderBottom: index < fees.length - 1 ? "1px solid #eceff2" : "none",
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 14.5, fontWeight: 600, color: "#0f172a" }}>
              {fee.gradeName} · Section {fee.sectionName}
            </Typography>
            <Typography sx={{ fontSize: 12.5, color: "text.secondary", mt: 0.25 }}>
              Term {fee.terms} ·{" "}
              <Box component="span" sx={{ fontWeight: 600, color: "#0f172a" }}>
                &#8377;{Number(fee.amount).toLocaleString("en-IN")}
              </Box>
            </Typography>
          </Box>
          <Tooltip title="Print receipt">
            <IconButton
              size="small"
              aria-label="Print receipt"
              onClick={() => printReceipt(Number.parseInt(fee.receiptNo))}
              sx={{ color: "primary.main", flexShrink: 0 }}
            >
              <PrintOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};
